import PhotoSwipeLightbox from 'photoswipe/lightbox'
import PhotoSwipeSlideshow from './photoswipe-slideshow'


function registerGridMediaGallery() {

  const elems = document.querySelectorAll('.grid-media-gallery');

  if (elems.length <= 0) {
    return;
  }
  elems.forEach(function (elem) {

    const lightbox = new PhotoSwipeLightbox({
      gallery: elem,
      children: 'a',
      pswpModule: () => import('photoswipe'),
      bgOpacity: 1,
      showHideOpacity: true,
      showHideAnimationType: 'zoom'
    })

    const _slideshowPlugin = new PhotoSwipeSlideshow(lightbox, {
      // Plugin options, for example:
      defaultDelayMs: 4000, // 4 sec
    });

    lightbox.on('uiRegister', function () {
      lightbox.pswp.ui.registerElement({
        name: 'custom-caption',
        order: 9,
        isButton: false,
        appendTo: 'root',
        html: 'Caption text',
        onInit: (el, pswp) => {
          lightbox.pswp.on('change', () => {
            const slideElement = lightbox.pswp.currSlide.data.element
            let captionHtml = ''
            if (slideElement) {
              const captionContentElement = slideElement.querySelector('.pswp-caption-content')
              if (captionContentElement) {
                captionHtml = captionContentElement.innerHTML
              }
            }
            el.innerHTML = captionHtml
          })
        }
      })
    })

    lightbox.init();

  });
}

document.addEventListener('DOMContentLoaded', (event) => {
  registerGridMediaGallery()
})

